import config from '@app/config';

export function ensureTrailingSlash(rawUrl: string, append: boolean): string {
  if (!append || !rawUrl) {
    return rawUrl;
  }

  const cleaned = rawUrl.trim();
  const isAbsolute = /^[a-zA-Z][a-zA-Z\d+\-.]*:\/\//.test(cleaned);
  const base = config.baseUrl;

  try {
    decodeURIComponent(cleaned);
  } catch (e) {
    return rawUrl;
  }

  try {
    const url = new URL(cleaned, base);
    if (!url.pathname.endsWith('/')) {
      url.pathname += '/';
    }

    return isAbsolute ? url.toString() : url.pathname + url.search + url.hash;
  } catch (e) {
    return rawUrl;
  }
}
